import { ProcessedSystemLinkItem, SidebarMenuItemProps } from '../../../types';
import { useIsActiveLink } from '../useIsActiveLink';

import { SidebarItem } from './SidebarItem';

export const SidebarLinkItem = ({
  item,
  showIcon = true,
  isInDoubleDrop = false,
}: SidebarMenuItemProps<ProcessedSystemLinkItem['type']>) => {
  const { title, iconName, href } = item;

  const isActiveItem = useIsActiveLink(href);

  return (
    <SidebarItem
      showIcon={showIcon}
      href={href}
      iconName={iconName}
      aqaClass={`aqa_${title}`}
      title={title}
      isActive={isActiveItem}
      isInDoubleDrop={isInDoubleDrop}
    />
  );
};
